import React, { useState, useEffect } from "react";
import { domain } from "../auth/domain";
import UserRolePopup from "../components/branchesDialog";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";
import NoRecords from "../shared/NoRecords";
import {
  LinearProgress,
  Box,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  IconButton,
  Menu,
  MenuItem,
  TextField,
  InputAdornment,
  Button,
} from "@mui/material";
import { MoreVert, Search } from "@mui/icons-material";
import { useBranch } from "../contexts/BranchContext";

function Branches() {
  const accessToken = localStorage.getItem("accessToken");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [filteredUserTypes, setFilteredUserTypes] = useState([]);
  const [showSpinner, setShowSpinner] = useState(false);
  const [userTypes, setUserTypes] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [refreshTable, setRefreshTable] = useState("");
  const navigate = useNavigate();
  const { branch, setBranch } = useBranch();
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedBranch, setSelectedBranch] = useState(null);

  const handleMenuClick = (event, userType) => {
    setAnchorEl(event.currentTarget);
    setSelectedBranch(userType);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  // handle react page visibility based on open/clode of popup
  const handleToggleModal = (modalState) => {
    setIsModalOpen(modalState);
  };

  const handleTableRefresh = (info) => {
    setRefreshTable(info);
  };

  const handleDeleteBranch = async (userId) => {
    try {
      const result = await swal({
        title: "Are you sure you want to Delete this branch ?",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      });

      if (result) {
        const response = await fetch(
          domain + "branches/branches/" + userId + "/",
          {
            method: "DELETE",
            headers: {
              Authorization: "JWT " + accessToken,
            },
          }
        );

        if (response.ok) {
          swal({
            title: "success",
            text: "Branch deleted",
            icon: "success",
            buttons: false,
            timer: 2000,
          });
          handleMenuClose();
          handleTableRefresh(Math.random());
        } else {
          const body = await response.json();
          const details = body?.detail;
          swal({
            title: "Failed",
            text: details ? details : "Error occured",
            icon: "error",
            buttons: false,
          });
        }
      }
    } catch (error) {}
  };
  // Implement a function to handle the search functionality
  const handleSearch = (event) => {
    const query = event.target.value.toLowerCase();
    const filtered = userTypes.filter((userType) =>
      userType.name.toLowerCase().includes(query)
    );
    setFilteredUserTypes(filtered);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  // fetch Current users
  useEffect(() => {
    setShowSpinner(true);
    setBranch(branch);
    // Fetch user types
    fetch(domain + `branches/branches/`, {
      method: "GET",
      headers: {
        Authorization: "JWT " + accessToken,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data["detail"]) {
          swal({ icon: "info", title: data["detail"] });
          navigate("/dashboard");
        }
        setUserTypes(data);
        setFilteredUserTypes(data);
        setShowSpinner(false);
      })
      .catch((error) => console.error(error))
      .finally(() => {
        setShowSpinner(false);
      });
  }, [refreshTable, branch]);

  return (
    <Box sx={{ width: "100%" }}>
      {showSpinner && <LinearProgress />}
      <Paper sx={{ width: "100%", mb: 2, p: 2 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
          <Typography variant="h6" component="div">
            Branches
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <TextField
              size="small"
              placeholder="Search..."
              onChange={handleSearch}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                ),
              }}
              sx={{ mr: 2 }}
            />
            <UserRolePopup
              onToggleModal={handleToggleModal}
              onRefreshTable={handleTableRefresh}
              formTitle={"Add Branch"}
              btnName={"ADD"}
            >
              <Button
                variant="contained"
                color="primary"
                startIcon={<i className="fa fa-plus"></i>}
              >
                Add Branch
              </Button>
            </UserRolePopup>
          </Box>
        </Box>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>#</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Address</TableCell>
                <TableCell>Mobile</TableCell>
                <TableCell align="right">Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(rowsPerPage > 0
                ? filteredUserTypes.slice(
                    page * rowsPerPage,
                    page * rowsPerPage + rowsPerPage
                  )
                : filteredUserTypes
              ).map((userType, index) => (
                <TableRow hover key={userType.id}>
                  <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                  <TableCell>{userType.name}</TableCell>
                  <TableCell>{userType?.address}</TableCell>
                  <TableCell>{userType.phone_number}</TableCell>
                  <TableCell align="right">
                    <IconButton
                      onClick={(event) => handleMenuClick(event, userType)}
                    >
                      <MoreVert />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <NoRecords data={userTypes} />
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={filteredUserTypes.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        <UserRolePopup
          onToggleModal={handleToggleModal}
          onRefreshTable={handleTableRefresh}
          formTitle={"Update branch"}
          userId={selectedBranch?.id}
          onCloseMenu={handleMenuClose}
          btnName={'Edit'}
        >
          <MenuItem>
            <i className="fa fa-pencil m-r-5"></i> Edit
          </MenuItem>
        </UserRolePopup>
        <MenuItem onClick={() => handleDeleteBranch(selectedBranch?.id)}>
        <i className="fa fa-trash m-r-5"></i>
          Delete
        </MenuItem>
      </Menu>
    </Box>
  );
}

export default Branches;
